import { TxType } from '@orionprotocol/sdk';
import { createSelector } from '@reduxjs/toolkit';

import { RootStateType } from '../store';

export const getQueuedTransactions = createSelector(
  (state: RootStateType) => state.transactions,
  (transactions) =>
    transactions.transactions.filter((tx) => tx.status === 'queued'),
);
export const getPendingTransactions = createSelector(
  (state: RootStateType) => state.transactions,
  (transactions) =>
    transactions.transactions.filter((tx) => tx.status === 'pending'),
);
export const getAllTransactions = (state: RootStateType) =>
  state.transactions.transactions;
export const getTransactionByHash =
  (state: RootStateType) => (hash: string | undefined) =>
    state.transactions.transactions.find((tx) => tx.hash === hash);
export const getWithdrawTransactions = createSelector(
  getAllTransactions,
  (transactions) =>
    transactions.filter((tx) => tx.payload?.type === TxType.WITHDRAW),
);
export const getDepositTransactions = createSelector(
  getAllTransactions,
  (transactions) =>
    transactions.filter((tx) => tx.payload?.type === TxType.DEPOSIT),
);
export const getWithdrawDepositTransactions = createSelector(
  getAllTransactions,
  (transactions) =>
    transactions.filter(
      (tx) =>
        tx.payload?.type === TxType.DEPOSIT ||
        tx.payload?.type === TxType.WITHDRAW,
    ),
);

export const getSwapThroughOrionPoolTransactions = createSelector(
  getAllTransactions,
  (transactions) =>
    transactions.filter(
      (tx) => tx.payload?.type === TxType.SWAP_THROUGH_ORION_POOL,
    ),
);

export const getTransactionInSigningId = (state: RootStateType) =>
  state.transactions.transactionInSigningId;
export const getTransactionInSigning = (state: RootStateType) =>
  state.transactions.transactions.find(
    (tx) => tx.id === state.transactions.transactionInSigningId,
  );
